export default {"src":"/_next/static/media/facebook_hover.8f642fe9.svg","height":44,"width":44};